import store from '../store'

/*
    This will cehck to see if the user is authenticated or not.
*/
export default async function requireAuth (to, from, next) {
  /*
    Confirms the user has been loaded
    */
  if (!store.state.base.userId) {
    /*
        If not, load the user
      */
    try {
      await store.dispatch('loadUser')
      await store.dispatch('userStatus')
    } catch (err) {
      console.log('error :', err.code)
    }
    if (store.state.base.userId) {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
}
